import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Carousel } from 'components/core/Carousel';
import { Image } from 'components/core/Image';
import { compose, lifecycle } from 'recompose';

import './imageCarousel.scss';

export function ImageCarousel({
	images,
	className
}) {
	return (
		<div className="carousel-container">
			<Carousel
				className={classnames('ph-image-carousel', className)}
			>
				{!!images.length && Children.toArray(images.map((image) => (
					<Image
						src={image.src}
						alt={image.alt}						
					/>
				)))}
			</Carousel>
		</div>
	);
}

ImageCarousel.propTypes = {
	className: PropTypes.string,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string.isRequired,
			alt: PropTypes.string
		})
	),
	preload: PropTypes.bool,
};

ImageCarousel.defaultProps = {
	images: [],
	preload: false,
};
const enhance = compose(
    lifecycle({
        componentDidMount() {
            const { preload, images } = this.props;
            if (preload && images && images.length > 0) {				
                const preloadLink = document.createElement('link');
                preloadLink.rel = 'preload';
                preloadLink.as = 'image';
                preloadLink.href = images[0].src 
                document.head.appendChild(preloadLink);
            }
        },
    })
);

export default enhance(ImageCarousel);
